/* FH-A11Y audit 2026-10-01: fixes from the October accessibility audit (search arrow-key fix added
   2026-10-02 when merging). Rollback: delete the two include lines for this batch at the end of snippets/freshdesk.liquid. */
(function () {
  'use strict';

  /* Audit item 3 (WCAG 1.4.10): on phones the collection banner is fixed at 300px high, so a long collection
     description was cut off at the bottom. Grow the banner to fit its text; short banners are left alone. */
  function fitCollectionBanner() {
    if (!document.body.classList.contains('collection')) return;
    var banner = document.querySelector('slideshow-component .slideshow.banner');
    if (!banner) return;
    banner.style.removeProperty('height');
    if (window.innerWidth > 767) return;
    var slide = banner.querySelector('.slideshow__slide');
    if (!slide) return;
    var needed = Math.ceil(slide.getBoundingClientRect().height);
    if (needed > banner.clientHeight + 1) {
      banner.style.setProperty('height', needed + 'px', 'important');
    }
  }

  /* Audit item 6 (WCAG 1.3.1): the gift card balance page had no level 1 heading. Same approach as the
     collection and article titles: keep the look, expose the page title as level 1. */
  function fixGiftBalanceHeading() {
    if (!document.body.classList.contains('check-balance-page')) return;
    if (document.querySelector('h1, [aria-level="1"]')) return;
    var heading = document.querySelector('.gvl-balance__header h2');
    if (heading) heading.setAttribute('aria-level', '1');
  }

  /* Audit item 5 (WCAG 2.4.4, 4.1.2): blog pagination. The previous and next arrows had no name and the page
     links read only as a number. */
  function labelBlogPagination() {
    var lists = document.querySelectorAll('.ecom-pagination-navigation');
    for (var i = 0; i < lists.length; i++) {
      var items = lists[i].querySelectorAll('li');
      for (var j = 0; j < items.length; j++) {
        var li = items[j];
        var target = li.querySelector('a') || li;
        var text = (li.textContent || '').replace(/\s+/g, '');
        var label = null;
        if (li.matches('.ecom-prev') || li.querySelector('.ecom-prev')) label = 'Previous page';
        else if (li.matches('.ecom-next') || li.querySelector('.ecom-next')) label = 'Next page';
        else if (/^\d+$/.test(text)) label = 'Page ' + text;
        if (label && target.getAttribute('aria-label') !== label) target.setAttribute('aria-label', label);
      }
    }
  }

  /* Audit item 1 (WCAG 2.1.1, 4.1.2): instant search results (Globo).
     a) Arrow keys. The search app has its own arrow-key support, but it gives each result tabindex="-1" and then
        skips results that have tabindex="-1" unless they carry its "gl-focusable-item" class, so Down/Up did
        nothing (found 2026-10-02). Adding that class makes the app accept its own results again.
     b) Each result also has a second, unnamed image link inside the listbox. Hide the duplicate from assistive
        technology and the Tab order so the list holds only its options. Done only when the results can be
        reached with the arrow keys (a), so keyboard users never lose their way in. */
  function tidySearchResults() {
    var list = document.getElementById('gl-search-listbox');
    if (!list) return;
    var options = list.querySelectorAll('a[role="option"]');
    for (var k = 0; k < options.length; k++) {
      if (!options[k].classList.contains('gl-focusable-item')) options[k].classList.add('gl-focusable-item');
    }
    if (!options.length) return;
    var extras = list.querySelectorAll('a:not([role="option"]):not([aria-hidden="true"])');
    for (var i = 0; i < extras.length; i++) {
      extras[i].setAttribute('aria-hidden', 'true');
      extras[i].setAttribute('tabindex', '-1');
    }
  }

  /* Audit item 7 (WCAG 1.3.1): on the collections list the page title is level 1 and the collection names were
     level 3, skipping level 2. */
  function fixCollectionListHeadings() {
    if (!document.body.classList.contains('list-collections')) return;
    if (!document.querySelector('h1, [aria-level="1"]')) return;
    var cards = document.querySelectorAll('.collection-list h3.card__heading:not([aria-level])');
    for (var i = 0; i < cards.length; i++) cards[i].setAttribute('aria-level', '2');
  }

  function runAll() {
    try { fitCollectionBanner(); } catch (e) {}
    try { fixGiftBalanceHeading(); } catch (e) {}
    try { labelBlogPagination(); } catch (e) {}
    try { tidySearchResults(); } catch (e) {}
    try { fixCollectionListHeadings(); } catch (e) {}
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; runAll(); }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runAll);
  else runAll();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  if (window.MutationObserver && document.body) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
})();
